module.exports = __webpack_public_path__ + "static/media/bytt-no-7.67b0a6ab.mp3";